import * as React from 'react';

import * as styles from './DoubleColumnMasonryLayout.css';

export const DoubleColumnMasonryLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const childArray = React.Children.toArray(children);
  const evenChildren = childArray.filter((_child, index) => index % 2 === 0);
  const oddChildren = childArray.filter((_child, index) => index % 2 !== 0);

  return (
    <>
      <div className={styles['even']}>{evenChildren}</div>
      <div className={styles['odd']}>{oddChildren}</div>
    </>
  );
};
